<template>
  <div>
    <div class="box" v-if="!isLaunchpack">
      <admin-box-item title="내 서비스 관리비">
        <div>
          <div>
            <div>사용 가능 관리비</div>
            <div>{{ fee_info }}</div>
          </div>
          <div>
            <div>차감 예정 관리비</div>
            <div>{{ fee_info }}</div>
          </div>
          <div>
            <div>월 이용 관리비</div>
            <div>{{ fee_info }}</div>
          </div>
        </div>
      </admin-box-item>
    </div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="관리비 충전 내역"
      ref="admin_filter"
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1500"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="price" slot-scope="props">
        {{ props.item.price | currency }}
      </div>
      <div slot="card_bill_info" slot-scope="props">
        <div v-if="props.item.card_bill_info">{{ props.item.card_bill_info.bank }} {{ props.item.card_bill_info.num }}</div>
      </div>
    </admin-table>

  </div>
</template>
<script>
  import ListMixin from '@/mixins/ListMixin'
  export default {
    name: "ManagementFee",
    mixins: [
      ListMixin
    ],
    created() {
      this.init();
      if(!this.isLaunchpack) {
        this.getMyFeeInfo();
      }
    },
    data() {
      return {
        fee_info: undefined
      }
    },
    methods: {
      init() {
        this.initializing('launchpack_management_fee_add', 'launchpack/management/fee?management_type=0');
      },
      getDataFromServer() {
        this.getData();
      },
      getMyFeeInfo() {
        this.$axios.get('admin/launchpack/my/management_fee/info').then(res=>{
          this.fee_info = res.data;
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
</style>
